export default __webpack_public_path__ + "static/media/linkedin.f70072de.svg";